import type * as Api from '@ViewModels';

export type SendEmailGuardResult = { canSend: true } | { canSend: false; message: string };

export const RESOLVE_ERROR_MESSAGE = "We couldn't load recipients for the selected meetings. Please try again.";
export const NO_CONTACTS_MESSAGE = 'No contacts found for the selected meetings.';

/**
 * Decides whether the Meetings "send email" flow may open the composer. Blocks (with a message to
 * toast) when contact resolution failed or produced zero recipients, so the user never lands in an
 * empty composer.
 */
export const getSendEmailGuardResult = (
	resolveFailed: boolean,
	matchingContacts: Api.IProjectedContact[]
): SendEmailGuardResult => {
	if (resolveFailed) {
		return { canSend: false, message: RESOLVE_ERROR_MESSAGE };
	}
	if (matchingContacts.length === 0) {
		return { canSend: false, message: NO_CONTACTS_MESSAGE };
	}
	return { canSend: true };
};
